export default __webpack_public_path__ + "static/media/subscribe-today-bottom-bg@2x.9a2b05e2.png";